export default __webpack_public_path__ + "static/media/tituloES.c228af65.png";